<div class="login login-container">
  <div class="bg">
    <div class="login-bg-backdrop">
      <img
        src="/assets/images/catman-logo-white-black.png"
        class="login-banner-logo"
      />
    </div>
  </div>
  <div class="login-section">
    <form>
      <div class="login-logo logo-pho"></div>
      <div>
        <h4 *ngIf="signUp" class="login-head">User On Boarding</h4>
      </div>
      <ng-container *ngIf="!signUp">
        <div>
          <button class="btn btn-primary login-btn" (click)="login()">
            <span class="login-btn-text">Login with ABInBev</span>
            <img
              class="collection-forward"
              src="/assets/images/white-arrow.svg"
            />
          </button>
        </div>
        <div>
          <p class="form-check-label my-4">
            Don’t have an account?
            <a href="/home#onboarding" class="login-sign-up"
              >Raise onboarding request</a
            >
          </p>
        </div>
      </ng-container>
    </form>
  </div>
</div>
